module.exports = __webpack_public_path__ + "static/img/aboutus.71db875a.jpg";